module.exports = __webpack_public_path__ + "static/media/background.0e99eb52.jpg";